import styled from 'styled-components'

export const GroupDialogHeaderStyles = styled.header`
  display: flex;
  justify-content: space-between;
  padding: 2.4rem;
  gap: 2rem;
`
